import * as _ from 'lodash';
import { FormControlBase } from './form-control-base';
import { FormControlData } from './form-control-data';

export class NumberControl extends FormControlBase<number> {
  controlType = 'number';
  min?: number = 0;
  step?: number = 1;
  decimalPlaces?: number = 5;

  constructor(options: FormControlData<number> = {}) {
    super(options);

    if (options.options) {
      this.min = options.options.min !== undefined ? options.options.min : this.min;
      this.step = options.options.step !== undefined ? options.options.step : this.step;
      this.decimalPlaces = options.options.decimalPlaces !== undefined ? options.options.decimalPlaces : this.decimalPlaces;
    }
  }

  protected initialize() {
    let val: number = _.get(this.model, this.propertyName) as number;
    // 0 is a valid value but will eval to `false` when tested for truthiness
    if (val || val === 0) {
      val = Number.parseFloat(val.toString());

      this.value = +val.toFixed(this.decimalPlaces);
    }
  }
}
